/* tslint:disable */
/* eslint-disable */
/**
 * B2B Air Seats
 * Endpoints needed to manage flight seats  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.get_seat_map.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.get_seat_map.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `bad_request` * `duplicate_booking` * `duplicated_national_id` * `duplicated_passport` * `expired_national_id` * `expired_passport` * `expiring_national_id` * `expiring_passport` * `flight_cancelled` * `flight_schedule_change` * `gordian_reconciliation` * `illegal_lap_infant_ktn` * `illegal_lap_infant_redress` * `internal_error` * `invalid_passenger_name` * `invalid_passengers` * `invalid_passport_number` * `invalid_passport_or_national_id_number` * `lap_infant_too_old` * `lap_infants_unsupported` * `legacy_cancellation` * `malformed_known_traveler_number` * `malformed_redress_number` * `missing_national_id` * `missing_nationality` * `missing_passport_number` * `missing_passport_or_national_id` * `missing_passport` * `no_adult_passenger` * `no_availability` * `no_contact_information` * `passenger_name_too_short` * `request_deserialization_error` * `response_serialization_error` * `seated_infants_unsupported` * `seats_info_failure` * `seats_info_ineligible` * `service_error` * `session_closed` * `too_many_lap_infants` * `too_many_passengers` * `unexpected_gordian_web_seat_map` * `unknown` * `unsupported_name_characters` * `upgrade_required`  
 *
 * The version of the OpenAPI document: v0p30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

export interface AccountPrice {
    'currency': string;
    'value': number;
    'currencyDescription'?: string;
}
/**
 * A cash amount
 * @export
 * @interface FiatPrice
 */
export interface FiatPrice {
    'currencyCode': string;
    'currencySymbol': string;
    'value': number;
}
export const FulfillAncillaryType = {
    bag: 'bag',
    seat: 'seat'
} as const;

export type FulfillAncillaryType = typeof FulfillAncillaryType[keyof typeof FulfillAncillaryType];


export interface GetSeatMapRequest {
    'callback': SeatMapCallback;
}
export interface GetSeatMapResponse {
    'html': string;
    'cheapestSeat': Prices;
}
export interface GordianPriceObject {
    'base_price': number;
    'decimal_places': number;
    'total': number;
    'usd_base_price': number;
    'currency': string;
    'usd_markup_amount': number;
    'markup_amount': number;
    'usd_total': number;
}
export interface GordianSeat {
    'pax_id': string;
    'session_id': number;
    /**
     * 2 character IATA Airline code
     * @type {string}
     * @memberof GordianSeat
     */
    'carrier': string;
    'unique_id': number;
    'price': string;
    'person_id': string;
    'display_name': string;
    'product_type': FulfillAncillaryType;
    'price_object': GordianPriceObject;
    'flight_string': string;
    'product_id': string;
    'currency': string;
    'seat_id': string;
    'agent_id': string;
}


/**
 * Price in fiat currency as well as any with rewards/account specific currency
 * @export
 * @interface Prices
 */
export interface Prices {
    'fiat': FiatPrice;
    'accountSpecific': { [key: string]: AccountPrice; };
}
export interface SeatMapCallback {
    'value': any;
}
/**
 * NonEmpty List of Gordian Seats to purchase
 * @export
 * @interface SelectSeatsCommand
 */
export interface SelectSeatsCommand {
    'seats': Array<GordianSeat>;
}
/**
 * Information necessary to add a Seats product to the shopping cart

 * `command` - NonEmpty List of Gordian Seats to purchase
 * `shoppedProductId` - The shopped tripId. Used to associate seats to a Flight
 * `bookingSessionId` - BookingSession / ClientToken. Temporarily used to associate seats to Flight Booking Session
 * @export
 * @interface SelectSeatsRequest
 */
export interface SelectSeatsRequest {
    'command': SelectSeatsCommand;
    /**
     * The shopped tripId. Used to associate seats to a Flight
     * @type {string}
     * @memberof SelectSeatsRequest
     */
    'shoppedProductId': string;
    /**
     * BookingSession / ClientToken. Temporarily used to associate seats to Flight Booking Session
     * @type {string}
     * @memberof SelectSeatsRequest
     */
    'bookingSessionId'?: string;
}
/**
 * Information necessary to add a Seats product to the shopping cart using v2 flow

 * `command` - NonEmpty List of Gordian Seats to purchase
 * `shoppedProductId` - The shopped tripId. Used to associate seats to a Flight
 * `reservationId` - Quoted flight reservation id
 * `seatsClientToken` - Token used to create a seats product in the cart
 * @export
 * @interface SelectSeatsRequestV2
 */
export interface SelectSeatsRequestV2 {
    'command': SelectSeatsCommand;
    /**
     * The shopped tripId. Used to associate seats to a Flight
     * @type {string}
     * @memberof SelectSeatsRequestV2
     */
    'shoppedProductId': string;
    /**
     * Quoted flight reservation id
     * @type {string}
     * @memberof SelectSeatsRequestV2
     */
    'reservationId': string;
    /**
     * Token used to create a seats product in the cart
     * @type {string}
     * @memberof SelectSeatsRequestV2
     */
    'seatsClientToken': string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get seat map data and iframe
         * @param {GetSeatMapRequest} getSeatMapRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SeatsSeatMapPost: async (getSeatMapRequest: GetSeatMapRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'getSeatMapRequest' is not null or undefined
            assertParamExists('apiV0SeatsSeatMapPost', 'getSeatMapRequest', getSeatMapRequest)
            const localVarPath = `/api/v0/seats/seatMap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getSeatMapRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * Get seat map data and iframe
         * @param {GetSeatMapRequest} getSeatMapRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV0SeatsSeatMapPost(getSeatMapRequest: GetSeatMapRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSeatMapResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV0SeatsSeatMapPost(getSeatMapRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * Get seat map data and iframe
         * @param {GetSeatMapRequest} getSeatMapRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV0SeatsSeatMapPost(getSeatMapRequest: GetSeatMapRequest, options?: any): AxiosPromise<GetSeatMapResponse> {
            return localVarFp.apiV0SeatsSeatMapPost(getSeatMapRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * Get seat map data and iframe
     * @param {GetSeatMapRequest} getSeatMapRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public apiV0SeatsSeatMapPost(getSeatMapRequest: GetSeatMapRequest, options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).apiV0SeatsSeatMapPost(getSeatMapRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



